// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_h2-6";
export var emphasizeQuantity = "_h2-3";
export var flatBottomCorners = "_h2-5";
export var productImage = "_h2-0";
export var quantityContainer = "_h2-2";
export var tooltip = "_h2-1";
export var wrapAndEllipsesOverflow = "_h2-4";